import React from "react";
import cn from "classnames";
import type { Action as ActionType } from "@ui/Highcharts/ui/Tooltip";
import classNames from "classnames";
import { css } from "@linaria/core";
import Text from "@ui/Text";
import { color, fonts } from "@ui";
import { spacings } from "@ui/Theme";
import { Action } from "..";

export enum QuantityValidityTooltipAction {
  Validate = "Validate",
  Invalidate = "Invalidate",
}

const validityQuantity = css`
  display: flex;
  flex-direction: column;
  gap: ${spacings.xs};
`;

const description = css`
  white-space: pre-wrap;
  width: 100%;
  margin-top: 8px;
  color: ${color.carbon900};
  &.invalidColor {
    color: ${color.raw.oxygen400};
  }
  &.partialColor {
    color: ${color.raw.darkNitrogen600};
  }
`;

const action = css`
  display: flex;
  font: ${fonts.body2};
  gap: 8px;
`;

interface P {
  actionDescription: string;
  isInvalid: boolean | null;
  isPartial: boolean;
  actions: ActionType<QuantityValidityTooltipAction>[];
  selectedCount: number;
}

export const ValidityQuantityChartTooltip = ({
  actionDescription,
  isInvalid,
  isPartial,
  actions,
  selectedCount,
}: P) => (
  <div className={validityQuantity}>
    {selectedCount <= 1 ? (
      <Text
        type="body2SemiBold"
        className={classNames(description, {
          invalidColor: isInvalid === true,
          partialColor: isPartial,
        })}
      >
        {actionDescription}
      </Text>
    ) : null}
    {actions.length && selectedCount ? (
      <div className={action}>
        {actions
          .filter(a => a.show)
          .map(a => (
            <Action
              key={a.action}
              className={cn({ [a.intent]: true, fullWidth: a.fullWidth })}
              data-action={a.action}
            >
              {a.text}
            </Action>
          ))}
      </div>
    ) : null}
  </div>
);
